import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/global.css';
import '../styles/Landing.css';

const Section = ({ title, children }: { title: string; children: React.ReactNode }) => (
  <div style={{ borderTop: '1px solid var(--border)', paddingTop: 32, marginBottom: 32 }}>
    <h2 style={{ fontSize: 20, fontWeight: 700, marginBottom: 14 }}>{title}</h2>
    <div style={{ color: 'var(--muted)', fontSize: 14, lineHeight: 1.9 }}>{children}</div>
  </div>
);

const Privacy = () => (
  <div className="landing-bg" style={{ minHeight: '100vh' }}>
    <div className="landing-orbs">
      <div className="orb1" /><div className="orb2" /><div className="orb3" />
    </div>

    <nav className="navbar">
      <Link to="/" style={{ textDecoration: 'none' }}><div className="logo">my<em>linx</em></div></Link>
      <div className="nav-links">
        <Link to="/login" className="nav-a">Login</Link>
        <Link to="/register" className="btn-main" style={{ padding: '10px 22px', fontSize: 12 }}>Get Started ↗</Link>
      </div>
    </nav>

    <div style={{ maxWidth: 720, margin: '0 auto', padding: '80px 24px 60px' }}>
      <div className="tag" style={{ marginBottom: 20, display: 'inline-flex' }}>Legal</div>
      <h1 style={{ fontSize: 42, fontWeight: 800, marginBottom: 12 }}>Privacy Policy</h1>
      <p style={{ color: 'var(--muted)', fontSize: 14, marginBottom: 40 }}>
        Last updated: October 2026 · We take your privacy seriously.
      </p>

      <Section title="1. Information We Collect">
        <p><strong style={{ color: 'inherit' }}>Account information:</strong> When you register, we collect your name, email address, and username.</p>
        <br />
        <p><strong style={{ color: 'inherit' }}>Profile content:</strong> Links, bio, avatar, and social media handles you add to your profile.</p>
        <br />
        <p><strong style={{ color: 'inherit' }}>Usage data:</strong> We collect analytics data including profile views, link clicks, device type, browser, operating system, and approximate location (country/city) from visitor IP addresses.</p>
        <br />
        <p><strong style={{ color: 'inherit' }}>Payment information:</strong> Payment details are processed by Razorpay (India) or Dodo Payments (international). We do not store your card details.</p>
      </Section>

      <Section title="2. How We Use Your Information">
        <ul style={{ paddingLeft: 20 }}>
          <li style={{ marginBottom: 8 }}>To provide and maintain your mylinx profile</li>
          <li style={{ marginBottom: 8 }}>To send you important account notifications and emails</li>
          <li style={{ marginBottom: 8 }}>To process payments for PRO subscriptions</li>
          <li style={{ marginBottom: 8 }}>To show you analytics about your profile visitors</li>
          <li style={{ marginBottom: 8 }}>To improve our product and fix issues</li>
        </ul>
      </Section>

      <Section title="3. Data We Do NOT Sell">
        <p style={{ fontWeight: 700, color: 'inherit', marginBottom: 10 }}>We will never sell your personal data or your subscribers' email addresses to third parties. Ever.</p>
        <p>Your subscribers trust you with their emails — we treat that trust with the highest respect.</p>
      </Section>

      <Section title="4. Cookies & Tracking">
        <p>We use minimal cookies required for authentication (keeping you logged in). We also use Google Analytics to understand overall product usage. We do not use advertising cookies or cross-site tracking.</p>
      </Section>

      <Section title="5. Data Sharing">
        <p>We share data only with:</p>
        <ul style={{ paddingLeft: 20, marginTop: 10 }}>
          <li style={{ marginBottom: 6 }}>Payment processors (Razorpay, Dodo Payments) for billing</li>
          <li style={{ marginBottom: 6 }}>Email service providers (Resend) for sending notifications</li>
          <li style={{ marginBottom: 6 }}>Cloud infrastructure providers for hosting</li>
        </ul>
        <br />
        <p>We never share your data for advertising purposes.</p>
      </Section>

      <Section title="6. Data Retention">
        Your data is retained as long as your account is active. When you delete your account, all personal data is deleted within 30 days. Anonymized analytics data may be retained longer for product improvement purposes.
      </Section>

      <Section title="7. Your Rights">
        <p>You have the right to:</p>
        <ul style={{ paddingLeft: 20, marginTop: 10 }}>
          <li style={{ marginBottom: 6 }}>Access your personal data at any time from your dashboard</li>
          <li style={{ marginBottom: 6 }}>Delete your account and all associated data</li>
          <li style={{ marginBottom: 6 }}>Export your subscriber list as CSV</li>
          <li style={{ marginBottom: 6 }}>Request a copy of your data by emailing us</li>
        </ul>
      </Section>

      <Section title="8. Security">
        We use industry-standard security practices including encrypted passwords (bcrypt), HTTPS, JWT authentication, and rate limiting. However, no system is 100% secure — please use a strong, unique password.
      </Section>

      <Section title="9. Children's Privacy">
        mylinx.in is not intended for children under 13. We do not knowingly collect data from children under 13. If you believe a child has provided us with personal information, please contact us immediately.
      </Section>

      <Section title="10. Changes to This Policy">
        We may update this privacy policy from time to time. We will notify you of significant changes by email. Continued use of mylinx.in after changes constitutes acceptance of the new policy.
      </Section>

      <Section title="11. Contact">
        For privacy-related questions or requests, contact us at{' '}
        <a href="mailto:support@mylinx.in" style={{ color: 'var(--accent)' }}>support@mylinx.in</a>.
      </Section>
    </div>

    <footer className="footer">
      <Link to="/" style={{ textDecoration: 'none' }}><div className="logo">my<em>linx</em></div></Link>
      <div className="footer-copy">MADE WITH OBSESSION © 2026</div>
      <div className="footer-links">
        <Link to="/about" className="footer-a">About</Link>
        <Link to="/contact" className="footer-a">Contact</Link>
        <Link to="/terms" className="footer-a">Terms</Link>
        <Link to="/privacy" className="footer-a">Privacy</Link>
        <Link to="/refund" className="footer-a">Refund</Link>
      </div>
    </footer>
  </div>
);

export default Privacy;